import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '@dss-libs/shared/ui/common-components';

@Component({
  selector: 'juno-libs-ui-account-info-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './account-info-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountInfoSkeletonComponent {}
